<template>
  <div id="app" style="min-height: 100vh">
    <a-layout id="components-layout-demo-custom-trigger">
      <a-layout-sider
        v-model="collapsed"
        :trigger="null"
        collapsible
        width="230"
      >
        <div
          style="font-size: 120%; margin-top: 20px; text-align: center"
          @click="goHome()"
          onmouseover="this.style.cursor='pointer'"
        >
          <h2>
            <a-icon type="bank" style="color: white" />
            <span style="color: white; margin-left: 1px; user-select: none"
              >Home</span
            >
          </h2>
        </div>
        <div
          class="logo"
          style="text-align: center; user-select: none"
          v-if="!collapsed"
          @click="goHome()"
          onmouseover="this.style.cursor='pointer'"
        >
          <h2 style="color: white; text-align: center">
            <span> Welcome to</span>
          </h2>
          <h2>
            <span
              style="
                color: rgb(227, 141, 79);
                font-weight: bold;
                font-size: 100%;
              "
              >RBP</span
            >
            <span style="font-weight: bold; font-size: 100%; color: white"
              >World!</span
            >
          </h2>
        </div>
        <a-menu
          theme="dark"
          mode="inline"
          :selected-keys="this.selectKey"
          :open-keys="openKeys"
          @openChange="onOpenChange"
        >
          <a-menu-item key="1" @click="changekeys('1')">
            <a-icon type="chrome" style="font-size: 120%" />
            <span style="font-size: 17px; color: white; font-weight: bolder">
              Species</span
            >
            <router-link to="/species"></router-link>
          </a-menu-item>
          <a-menu-item key="2" @click="changekeys('2')">
            <a-icon type="bars" style="font-size: 120%" />
            <span style="font-size: 17px; color: white; font-weight: bolder">
              Families
            </span>
            <router-link to="/family"></router-link>
          </a-menu-item>
          <!-- <a-menu-item key="3">
            <a-icon type="medicine-box" style="font-size: 120%" />
            <span style="font-size: 120%"> Disease</span>
          </a-menu-item> -->
          <a-sub-menu key="3">
            <span slot="title"
              ><a-icon type="medicine-box" style="font-size: 120%" /><span
                style="font-size: 17px; color: white; font-weight: bolder"
              >
                Disease</span
              ></span
            >
            <a-menu-item
              key="cancers"
              @click="changekeys('cancers')"
              style="margin-left: -20px"
            >
              • Cancers <router-link to="/cancers"></router-link
            ></a-menu-item>
            <a-menu-item
              key="Genetic"
              @click="changekeys('Genetic')"
              style="margin-left: -20px"
            >
              • Genetic diseases <router-link to="/geneticDisease"></router-link
            ></a-menu-item>
            <!-- RNA viruse start-->
            <a-sub-menu key="RNAvirusDisease" style="margin-left: -20px">
              <span slot="title"> • RNA virus diseases </span>
              <a-menu-item
                key="SARSCoVtwo"
                @click="changekeys('SARSCoVtwo')"
                style="margin-left: -10px; font-size: 13px"
              >
                • SARS-CoV-2 virus <router-link to="/virus"></router-link
              ></a-menu-item>
              <a-menu-item
                key="Dengue"
                @click="changekeys('Dengue')"
                style="margin-left: -10px; font-size: 13px"
              >
                • Dengue virus <router-link to="/viruse"></router-link
              ></a-menu-item>
              <a-menu-item
                key="Zika"
                @click="changekeys('Zika')"
                style="margin-left: -10px; font-size: 13px"
              >
                • Zika virus <router-link to="/viruse"></router-link
              ></a-menu-item>
              <a-menu-item
                key="CHIKV"
                @click="changekeys('CHIKV')"
                style="margin-left: -10px; font-size: 13px"
              >
                • CHIKV virus <router-link to="/viruse"></router-link
              ></a-menu-item>
              <a-menu-item
                key="ncRNA"
                @click="changekeys('ncRNA')"
                style="margin-left: -10px; font-size: 13px"
              >
                • HIV virus <router-link to="/viruse"></router-link
              ></a-menu-item>
              <a-menu-item
                key="IAV"
                @click="changekeys('IAV')"
                style="margin-left: -10px; font-size: 13px"
              >
                • IAV virus <router-link to="/viruse"></router-link
              ></a-menu-item>
              <a-menu-item
                key="RV"
                @click="changekeys('RV')"
                style="margin-left: -10px; font-size: 13px"
              >
                • RV virus <router-link to="/viruse"></router-link
              ></a-menu-item>
              <a-menu-item
                key="SINV"
                @click="changekeys('SINV')"
                style="margin-left: -10px; font-size: 13px"
              >
                • SINV virus <router-link to="/viruse"></router-link
              ></a-menu-item>
              <a-menu-item
                key="VEEV"
                @click="changekeys('VEEV')"
                style="margin-left: -10px; font-size: 13px"
              >
                • VEEV virus <router-link to="/viruse"></router-link
              ></a-menu-item>
              <a-menu-item
                key="Flaviviruses"
                @click="changekeys('Flaviviruses')"
                style="margin-left: -10px; font-size: 13px"
              >
                • Flaviviruses virus <router-link to="/viruse"></router-link
              ></a-menu-item>
              <a-menu-item
                key="CovOCfourthree"
                @click="changekeys('CovOCfourthree')"
                style="margin-left: -10px; font-size: 13px"
              >
                • Cov-OC43 virus <router-link to="/viruse"></router-link
              ></a-menu-item>
            </a-sub-menu>
            <!-- RNA viruse end -->
            <a-menu-item
              key="drugs"
              @click="changekeys('drugs')"
              style="margin-left: -20px"
            >
              • Drugs <router-link to="/drugs"></router-link
            ></a-menu-item>
          </a-sub-menu>
          <a-sub-menu key="4">
            <span slot="title"
              ><a-icon type="read" style="font-size: 120%" /><span
                style="font-size: 17px; color: white; font-weight: bolder"
              >
                Functions</span
              ></span
            >
            <a-menu-item
              key="shRBP"
              @click="changekeys('shRBP')"
              style="margin-left: -20px"
            >
              • Downstream networks <router-link to="/shRBP"></router-link
            ></a-menu-item>
            <a-sub-menu key="rnaPartners" style="margin-left: -20px">
              <span slot="title"> • RNA partners</span>
              <!-- RNA partners -->
              <a-menu-item
                key="tRNA"
                @click="changekeys('tRNA')"
                style="margin-left: -10px; font-size: 13px"
              >
                • tRNA <router-link to="/drugs"></router-link
              ></a-menu-item>
              <a-menu-item
                key="mRNA"
                @click="changekeys('mRNA')"
                style="margin-left: -10px; font-size: 13px"
              >
                • mRNA <router-link to="/drugs"></router-link
              ></a-menu-item>
              <a-menu-item
                key="snoRNA"
                @click="changekeys('snoRNA')"
                style="margin-left: -10px; font-size: 13px"
              >
                • snoRNA <router-link to="/drugs"></router-link
              ></a-menu-item>
              <a-menu-item
                key="rRNA"
                @click="changekeys('rRNA')"
                style="margin-left: -10px; font-size: 13px"
              >
                • rRNA <router-link to="/drugs"></router-link
              ></a-menu-item>
              <a-menu-item
                key="ncRNA"
                @click="changekeys('ncRNA')"
                style="margin-left: -10px; font-size: 13px"
              >
                • ncRNA <router-link to="/drugs"></router-link
              ></a-menu-item>
              <a-menu-item
                key="snRNA"
                @click="changekeys('snRNA')"
                style="margin-left: -10px; font-size: 13px"
              >
                • snRNA <router-link to="/drugs"></router-link
              ></a-menu-item>
              <a-menu-item
                key="Diverse"
                @click="changekeys('Diverse')"
                style="margin-left: -10px; font-size: 13px"
              >
                • Diverse <router-link to="/drugs"></router-link
              ></a-menu-item>
            </a-sub-menu>
            <!-- mfRBP -->
            <a-sub-menu key="mfRBP" style="margin-left: -20px">
              <span slot="title"> • Moonlighting functions</span>
              <a-menu-item
                key="metabolic"
                @click="changekeys('metabolic')"
                style="font-size: 12px; margin-left: -10px"
              >
                • RNA-binding metabolic enzymes
                <router-link
                  :to="{
                    path: '/mfRBP',
                    query: { interactometype: 'metabolic' },
                  }"
                ></router-link
              ></a-menu-item>
              <a-menu-item
                key="E3s"
                @click="changekeys('E3s')"
                style="font-size: 12px; margin-left: -10px"
              >
                • RNA-binding E3 ligases
                <router-link
                  :to="{
                    path: '/mfRBP',
                    query: { interactometype: 'E3' },
                  }"
                ></router-link
              ></a-menu-item>
              <a-menu-item
                key="DUBs"
                @click="changekeys('DUBs')"
                style="font-size: 12px; margin-left: -10px"
              >
                • RNA-binding DUBs
                <router-link
                  :to="{
                    path: '/mfRBP',
                    query: { interactometype: 'DUBs' },
                  }"
                ></router-link
              ></a-menu-item>
              <a-menu-item
                key="kinases"
                @click="changekeys('kinases')"
                style="font-size: 12px; margin-left: -10px"
              >
                • RNA-binding kinases
                <router-link
                  :to="{
                    path: '/mfRBP',
                    query: { interactometype: 'kinases' },
                  }"
                ></router-link
              ></a-menu-item>
              <a-menu-item
                key="DRBPs"
                @click="changekeys('DRBPs')"
                style="font-size: 12px; margin-left: -10px"
              >
                • DNA-RNA binding proteins
                <router-link
                  :to="{
                    path: '/mfRBP',
                    query: { interactometype: 'DRBPs' },
                  }"
                ></router-link
              ></a-menu-item>
              <a-menu-item
                key="Transmemebranes"
                @click="changekeys('Transmemebranes')"
                style="font-size: 12px; margin-left: -10px"
              >
                • Transmemebrane RBPs
                <router-link
                  :to="{
                    path: '/mfRBP',
                    query: { interactometype: 'transmemebrane' },
                  }"
                ></router-link
              ></a-menu-item>
            </a-sub-menu>
            <!-- cond RBP -->
            <a-sub-menu key="Condensates" style="margin-left: -20px">
              <span slot="title"> • Condensates</span>
              <a-menu-item
                key="pBody"
                @click="changekeys('pBody')"
                style="margin-left: -10px; font-size: 13px"
              >
                • P-body <router-link to="/drugs"></router-link
              ></a-menu-item>
              <a-menu-item
                key="granule"
                @click="changekeys('granule')"
                style="margin-left: -10px; font-size: 13px"
              >
                • Stress granule <router-link to="/drugs"></router-link
              ></a-menu-item>
              <!-- Nucleolus -->
              <a-sub-menu key="Nucleolus" style="margin-left: -10px">
                <span slot="title"> • Nucleolus</span>
                <a-menu-item
                  key="Fibrillar"
                  @click="changekeys('Fibrillar')"
                  style="margin-left: -10px; font-size: 13px"
                >
                  • Fibrillar center <router-link to="/drugs"></router-link
                ></a-menu-item>
                <a-menu-item
                  key="Nucleoli"
                  @click="changekeys('Nucleoli')"
                  style="margin-left: -10px; font-size: 13px"
                >
                  • Nucleoli <router-link to="/drugs"></router-link
                ></a-menu-item>
                <a-menu-item
                  key="nRim"
                  @click="changekeys('nRim')"
                  style="margin-left: -10px; font-size: 13px"
                >
                  • Nucleoli rim <router-link to="/drugs"></router-link
                ></a-menu-item>
              </a-sub-menu>
            </a-sub-menu>
          </a-sub-menu>
          <a-sub-menu key="5">
            <span slot="title"
              ><a-icon type="pushpin" style="font-size: 120%" /><span
                style="font-size: 17px; color: white; font-weight: bolder"
              >
                Interactomes</span
              ></span
            >
            <!-- mfRBP -->
            <!-- <a-menu-item
              key="rbpRNA"
              @click="changekeys('rbpRNA')"
              style="margin-left: -20px"
            >
              • RBP-RNA
              <router-link
                :to="{
                  path: '/rbpRNA',
                }"
              ></router-link>
            </a-menu-item> -->
            <!-- <a-sub-menu key="mfRBP" style="margin-left: -20px">
              <span slot="title"> • RNA-RNA</span> -->
            <a-menu-item
              key="chirp"
              @click="changekeys('chirp')"
              style="margin-left: -20px"
            >
              • ChIRP-MS
              <router-link
                :to="{
                  path: '/interactome',
                  query: { interactometype: 'chirp' },
                }"
              ></router-link
            ></a-menu-item>
            <a-menu-item
              key="Uone"
              @click="changekeys('Uone')"
              style="margin-left: -20px"
            >
              • U1
              <router-link
                :to="{
                  path: '/interactome',
                  query: { interactometype: 'U1' },
                }"
              ></router-link>
            </a-menu-item>
            <a-menu-item
              key="Utwo"
              @click="changekeys('Utwo')"
              style="margin-left: -20px"
            >
              • U2
              <router-link
                :to="{
                  path: '/interactome',
                  query: { interactometype: 'U2' },
                }"
              ></router-link
            ></a-menu-item>
            <a-menu-item
              key="Uthree"
              @click="changekeys('Uthree')"
              style="margin-left: -20px"
            >
              • U3
              <router-link
                :to="{
                  path: '/interactome',
                  query: { interactometype: 'U3' },
                }"
              ></router-link
            ></a-menu-item>
            <a-menu-item
              key="fiveS"
              @click="changekeys('fiveS')"
              style="margin-left: -20px"
            >
              • 5S
              <router-link
                :to="{
                  path: '/interactome',
                  query: { interactometype: '5S' },
                }"
              ></router-link
            ></a-menu-item>
            <a-menu-item
              key="NORAD"
              @click="changekeys('NORAD')"
              style="margin-left: -20px"
            >
              • NORAD
              <router-link
                :to="{
                  path: '/interactome',
                  query: { interactometype: 'NORAD' },
                }"
              ></router-link
            ></a-menu-item>
            <a-menu-item
              key="RMRP"
              @click="changekeys('RMRP')"
              style="margin-left: -20px"
            >
              • RMRP
              <router-link
                :to="{
                  path: '/interactome',
                  query: { interactometype: 'RMRP' },
                }"
              ></router-link
            ></a-menu-item>
            <!-- </a-sub-menu> -->
          </a-sub-menu>
          <a-sub-menu key="6">
            <span slot="title"
              ><a-icon type="setting" style="font-size: 120%" /><span
                style="font-size: 17px; color: white; font-weight: bolder"
              >
                Tools</span
              ></span
            >
            <a-menu-item
              key="RBPredictor"
              @click="changekeys('RBPredictor')"
              style="margin-left: -20px"
            >
              • RBPredictor <router-link to="/RBPredictor"></router-link
            ></a-menu-item>
            <a-menu-item
              key="Blast"
              @click="changekeys('Blast')"
              style="margin-left: -20px"
            >
              • Blast <router-link to="/Blast"></router-link
            ></a-menu-item>
          </a-sub-menu>
          <a-sub-menu key="7">
            <span slot="title">
              <a-icon type="folder-open" style="font-size: 120%" /><span
                style="font-size: 17px; color: white; font-weight: bolder"
              >
                Dataset</span
              ></span
            >
            <a-menu-item
              key="rbpRNA"
              @click="changekeys('rbpRNA')"
              style="margin-left: -20px"
            >
              • CLIP-seq <router-link to="/rbpRNA"></router-link
            ></a-menu-item>
            <a-menu-item
              key="dataset"
              @click="changekeys('dataset')"
              style="margin-left: -20px"
            >
              • Bulk perturb-seq <router-link to="/dataset"></router-link
            ></a-menu-item>
          </a-sub-menu>
          <!-- <a-menu-item key="dataset" @click="changekeys('dataset')">
            <a-icon type="folder-open" style="font-size: 120%" />
            <span style="font-size: 17px; color: white; font-weight: bolder">
              Dataset </span
            ><router-link to="/dataset"></router-link>
          </a-menu-item> -->
          <a-menu-item key="download" @click="changekeys('download')">
            <a-icon type="cloud-download" style="font-size: 120%" />
            <span style="font-size: 17px; color: white; font-weight: bolder">
              Download</span
            >
            <router-link to="/download"></router-link>
          </a-menu-item>
          <!-- <a-menu-item key="helpDoc" @click="changekeys('helpDoc')">
            <a-icon type="coffee" style="font-size: 120%" />
            <span style="font-size: 120%"> Help</span>
            <router-link to="/helpDoc"></router-link>
          </a-menu-item> -->
        </a-menu>
      </a-layout-sider>
      <a-layout>
        <a-layout-header style="background: #fff; padding: 0">
          <a-icon
            class="trigger"
            :type="collapsed ? 'menu-unfold' : 'menu-fold'"
            @click="() => (collapsed = !collapsed)"
          />
          <a
            href="http://research.gzsys.org.cn/rbpworld/#/species_overview?species=Homo_sapiens&family="
            target="_blank"
            class="dashed-underline"
            >• Human</a
          >
          <a
            href="http://research.gzsys.org.cn/rbpworld/#/species_overview?species=Mus_musculus&family="
            target="_blank"
            style="margin-left: 20px"
            class="dashed-underline"
            >• Mouse</a
          >
          <a
            href="http://research.gzsys.org.cn/rbpworld/#/species_overview?species=Drosophila_melanogaster&family="
            target="_blank"
            style="margin-left: 20px"
            class="dashed-underline"
            >• Fly</a
          >
          <a
            href="http://research.gzsys.org.cn/rbpworld/#/species_overview?species=Caenorhabditis_elegans&family="
            target="_blank"
            style="margin-left: 20px"
            class="dashed-underline"
            >• Worm</a
          >
          <a
            href="http://research.gzsys.org.cn/rbpworld/#/species_overview?species=Arabidopsis_thaliana&family="
            target="_blank"
            style="margin-left: 20px"
            class="dashed-underline"
            >• Arabidopsis
          </a>
          <a
            href="http://research.gzsys.org.cn/rbpworld/#/species_overview?species=Oryza_sativa&family="
            target="_blank"
            style="margin-left: 20px"
            class="dashed-underline"
            >• Rice</a
          >
          <div style="float: right; margin-right: 10px; font-size: 140%">
            <span
              style="margin-top: 5px; margin-right: 12px"
              id="help"
              onmouseover="this.style.fontSize ='110%';this.style.color='#2A3F54'"
              onmouseleave="this.style.fontSize ='100%';this.style.color='grey'"
            >
              <a
                id="doc-link"
                target="_blank"
                href="http://eurbpdb.gzsys.org.cn/index.php"
                style="margin-right: 5px"
              >
                <img
                  src="http://research.gzsys.org.cn/rbpworld/images/links.png"
                  height="30"
                  width="30"
                />
                &nbsp;<a
                  href="http://eurbpdb.gzsys.org.cn/index.php"
                  target="_blank"
                  class="pointer"
                  onmouseover="this.style.color='#2A3F54'"
                  onmouseleave="this.style.color='grey'"
                  ><span style="color: black; margin-left: -6px">Eu</span
                  ><span style="color: rgb(227, 141, 79)">RBP</span
                  ><span style="color: black">DB</span></a
                >
              </a></span
            >
            <span
              style="margin-top: 5px; margin-right: 12px"
              id="help"
              onmouseover="this.style.fontSize ='110%';this.style.color='#2A3F54'"
              onmouseleave="this.style.fontSize ='100%';this.style.color='grey'"
            >
              <a
                id="doc-link"
                target="_blank"
                href="http://research.gzsys.org.cn/rbpworld/#/helpDoc"
                style="margin-right: 5px"
              >
                <img
                  src="http://research.gzsys.org.cn/rbpworld/images/help.png"
                  height="30"
                  width="30"
                />
                &nbsp;<a
                  href="http://research.gzsys.org.cn/rbpworld/#/helpDoc"
                  target="_blank"
                  class="pointer"
                  style="color: black"
                  onmouseover="this.style.color='#2A3F54'"
                  onmouseleave="this.style.color='black'"
                  >Help</a
                >
              </a></span
            >
            <span
              style="margin-top: 5px; margin-right: 12px"
              id="help"
              onmouseover="this.style.fontSize ='110%';this.style.color='#2A3F54'"
              onmouseleave="this.style.fontSize ='100%';this.style.color='grey'"
            >
              <a
                id="doc-link"
                target="_blank"
                href="http://eurbpdb.gzsys.org.cn/index.php"
                style="margin-right: 5px"
              >
                <img
                  src="http://research.gzsys.org.cn/rbpworld/images/contact-us.png"
                  height="30"
                  width="30"
                />
                &nbsp;<a
                  href="http://eurbpdb.gzsys.org.cn/index.php"
                  style="color: black"
                  target="_blank"
                  class="pointer"
                  onmouseover="this.style.color='#2A3F54'"
                  onmouseleave="this.style.color='black'"
                  >Contact</a
                >
              </a></span
            >
            <a-input-search
              placeholder="Search for"
              v-model="value"
              style="width: 200px"
              @search="onSearch"
            />
          </div>
        </a-layout-header>
        <a-layout-content
          :style="{
            margin: '12px 16px',
            padding: '12px',
            minHeight: '280px',
          }"
        >
          <!--此处是内容页的展示路由-->
          <router-view></router-view>
        </a-layout-content>
        <a-layout-footer style="text-align: center">
          <!-- <div style="text-align: center">
            <script
              type="text/javascript"
              src="//rf.revolvermaps.com/0/0/0.js?i=5r9y2mz7go4&amp;d=2&amp;p=3&amp;b=0&amp;w=293&amp;g=2&amp;f=arial&amp;fs=12&amp;r=0&amp;c0=362b05&amp;c1=375363&amp;c2=000000&amp;ic0=0&amp;ic1=0"
              async="async"
            ></script>
          </div> -->
          Copyright © 2023 - 2025, Bioinformatics Center, Sun Yat-sen Memorial
          Hospital, Sun Yat-sen University, China. All Rights Reserved.
        </a-layout-footer>
      </a-layout>
    </a-layout>
    <div id="components-back-top-demo-custom">
      <a-tooltip title="To the top" placement="right">
        <a-back-top>
          <div class="ant-back-top-inner">UP</div>
        </a-back-top>
      </a-tooltip>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    onSearch() {
      if (this.value != "") {
        let href =
          "http://research.gzsys.org.cn/rbpworld/#/searh_all?identity=" +
          this.value.trim();
        window.open(href, "_blank");
      }
    },
    onOpenChange(openKeys) {
      const latestOpenKey = openKeys.find(
        (key) => this.openKeys.indexOf(key) === -1
      );
      if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
        this.openKeys = openKeys;
      } else {
        this.openKeys = latestOpenKey ? [latestOpenKey] : [];
      }
    },
    goHome() {
      if (this.$route.path !== "/home") {
        this.selectKey = "";
        this.$router.push({
          name: "home",
        });
      }
    },
    changekeys(value) {
      this.selectKey = value;
    },
  },
  data() {
    return {
      value: "",
      collapsed: false,
      selectKey: "",
      rootSubmenuKeys: ["1", "2", "3", "4", "5", "6", "7", "8"],
      openKeys: [],
    };
  },
};
</script>
<style>
#components-layout-demo-custom-trigger .trigger {
  font-size: 18px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}

#components-layout-demo-custom-trigger .trigger:hover {
  color: #1890ff;
}

#components-layout-demo-custom-trigger .logo {
  height: 80px;
  background: rgba(255, 255, 255, 0.2);
  margin: 16px 0px;
}

.dashed-underline {
  position: relative;
  text-decoration: none;
  color: #000; /* 设置链接的颜色 */
}

.dashed-underline:after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -2px; /* 调整虚线与文字的距离 */
  width: 100%;
  border-bottom: 1px dashed #000; /* 设置虚线样式和颜色 */
  visibility: hidden; /* 默认情况下隐藏虚线装饰 */
  transition: visibility 0s, bottom 0.2s; /* 添加过渡效果，使下划线平滑出现 */
}

.dashed-underline:hover:after {
  visibility: visible; /* 鼠标放上去时显示虚线装饰 */
  bottom: -6px; /* 调整虚线与文字的距离，产生动画效果 */
}

#components-back-top-demo-custom .ant-back-top {
  bottom: 100px;
}
#components-back-top-demo-custom .ant-back-top-inner {
  height: 40px;
  width: 40px;
  line-height: 40px;
  border-radius: 20px;
  background-color: rgba(64, 64, 64, 0.6);
  color: #fff;
  text-align: center;
  font-size: 20px;
}
</style>
